export type Mark = "done" | "warn" | "err" | "todo";
export type StepState = {
  readOnly: boolean;
  hasPick: boolean;
  fieldNotes: number;
  valuesToCheck: number;
  valuesUnmapped: boolean;
  aiAgree: boolean | null;
};

export function stepMarks(s: StepState): [Mark, Mark, Mark] {
  if (s.readOnly) return ["done", "done", "done"];
  const field: Mark =
    !s.hasPick || s.fieldNotes > 0 || s.aiAgree === false ? "warn" : "done";
  const values: Mark = !s.hasPick
    ? "todo"
    : s.valuesToCheck > 0 || s.valuesUnmapped
      ? "warn"
      : "done";
  return [field, values, "todo"];
}
